import React from 'react';

const Twitter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 40 40"><path d="M30.4 3.75h5.517l-12.05 13.767 14.167 18.733h-11.083l-8.683 -11.367 -9.95 11.367H2.8l12.883 -14.733L2.083 3.75h11.383l7.85 10.383zm-1.933 29.2h3.067L11.8 6.883H8.533z"/></svg>
);

export default Twitter;
